import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormSkeleton } from '@globaleris/ui.library'

import { EnumPriceCalculationType } from '../../../api/Argentia/enums'
import Page from '../../../components/page/page'
import PageHeader from '../../../components/page/pageHeader'

import { TradeForm, FormMode } from '../components/tradeForm/tradeForm'
import { TRADES_TABS } from '../trades'

export interface TradeSimpleAddPageProps {}

export interface formDependencies {
  id?: number
  code?: string
  description?: string
  precioUnitario?: number
  marketType?: number
  commodity: number
  priceType: number
  redondeo?: number
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
}

export const TradesAddPage: React.FC<any> = props => {
  const [t] = useTranslation(['tradesEdit', 'globalerisLibrary', 'enums'])
  //Ends General Page States
  const currentTab = props.location.state.currentTab as TRADES_TABS
  const isFetching = false
  const isSimple = true

  //#endregion

  return isFetching ? (
    <Page fullWidth={false}>
      <PageHeader title={t('trades:title')}></PageHeader>
      <FormSkeleton withTitle={true} elevation={0} columns={1} inputs={9} />
    </Page>
  ) : (
    <TradeForm mode={FormMode.CREATE} tradeData={null} simple={isSimple} currentTab={currentTab} />
  )
}
